import { Config } from '@ratehub/base-ui';


/**
 * Returns true iff the given credit card provider id offers variable interest rates for
 * all of its cards. (Yes, we’re making some assumptions as of right now. We’ll revisit later if needed.)
 * As of 2025-Jun-16 this applies only to cards offered by Capital One.
 * @param {string} providerId
 * @returns {boolean}
 */
function isVariableInterestRate(providerId) {
    return providerId === Config.CAPITAL_ONE_PROVIDER_ID;
}


export default isVariableInterestRate;
